import {
    ApiHandlerDiscreteParameter,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { TellAFriendApiParameter } from "@insite/client-framework/Services/EmailService";
import {
    chain,
    SendDataToApi,
} from "@insite/client-framework/Store/CommonHandlers/ShareProduct";
import { ProductModel, TellAFriendModel } from "@insite/client-framework/Types/ApiModels";
import { tellAFriend } from "@tCentro/Services/EmailServiceExtension";

export interface ShareProductParameter {
    product: ProductModel;
    productDetailPath: string;
    friendsName: string;
    friendsEmailAddress: string;
    yourName: string;
    yourEmailAddress: string;
    yourMessage: string;
    onSuccess?: () => void;
}

type HandlerType = ApiHandlerDiscreteParameter<ShareProductParameter, TellAFriendApiParameter, TellAFriendModel>;

export const SendDataToApiExtended: HandlerType = async props => {
    props.apiResult = await tellAFriend(props.apiParameter);
};

replaceInChain(chain, SendDataToApi, SendDataToApiExtended);

